import request from '@/utils/http';
// 长合车变革试点车辆切换配置页面
// 分页查询接口
export const pilotVehicleSwitchPage = (data) => {
    return request({
        url: `/api-tms/billingPilotVehicleSwitchConfig/queryPage`,
        method: 'post',
        data
    });
};
// 批量删除接口
export const batchDeleteByIdList = (data) => {
    return request({
        url: `/api-tms/billingPilotVehicleSwitchConfig/deleteByIdList`,
        method: 'post',
        data
    });
};